<template>
  <div class="layout-container">
    <!-- 主要内容区域 -->
    <main class="main-content">
      <router-view />
    </main>
    <!-- 精简模式 /workflow2 未登录时显示登录弹窗（仅账号密码） -->
    <LoginDialog
      v-if="showWorkflowLoginDialog"
      v-model:visible="workflowLoginDialogVisible"
      :subtitle="$t('auth.login.subtitleWorkflow')"
      :show-register-button="false"
      redirect-path="/workflow2"
      @success="handleWorkflowLoginSuccess"
      @update:visible="handleWorkflowLoginDialogVisibleChange"
    />
  </div>
</template>

<script setup lang="ts">
import { useFavicon } from '@vueuse/core'
import { computed, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import LoginDialog from '@/components/auth/LoginDialog.vue'
import { useAuthStore } from '@/stores/authStore'

useFavicon('/assets/favicon.ico')

const route = useRoute()
const router = useRouter()
const authStore = useAuthStore()

const workflowLoginDialogVisible = ref(false)
/** 弹窗已稳定显示（避免挂载时误触发关闭导致的循环重定向） */
const dialogStableShownAt = ref<number>(0)

/** 精简模式 /workflow2 下未登录时显示登录弹窗 */
const showWorkflowLoginDialog = computed(
  () =>
    route.path.startsWith('/workflow2') &&
    authStore.isInitialized &&
    !authStore.isAuthenticated
)

watch(
  showWorkflowLoginDialog,
  (needShow) => {
    if (needShow) {
      workflowLoginDialogVisible.value = true
      dialogStableShownAt.value = Date.now()
    }
  },
  { immediate: true }
)

const handleWorkflowLoginSuccess = () => {
  workflowLoginDialogVisible.value = false
}

const handleWorkflowLoginDialogVisibleChange = (visible: boolean) => {
  if (!visible && !authStore.isAuthenticated) {
    // 仅当弹窗已稳定显示超过 300ms 后才重定向，避免挂载时误触发导致页面循环刷新
    const stableMs = 300
    if (
      dialogStableShownAt.value &&
      Date.now() - dialogStableShownAt.value > stableMs
    ) {
      void router.replace('/')
    }
  }
}
</script>

<style scoped>
.layout-container {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.main-content {
  flex: 1;
  overflow: hidden;
  position: relative;
}
</style>
